/**
 * 优惠券公共交互处理组件
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/1/30      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from "react";
import {symbolMoneyUtil, } from '@utils/utils';
import Locale from "@utils/locale";
const locale = Locale.current();
class CommonCoupon extends React.Component{
    constructor(props) {
        super(props);
        this.__getServerLanguage = __getServerLanguage;
    }

    render(){
        let {item} = this.props;
        let type = item.type||'discount';

        // 折扣券
        if(type ==='discount'){
            if(locale=='zh'){
                return (
                    <span className="common-coupon" dangerouslySetInnerHTML={{ __html: this.__getServerLanguage('NZheKou',`<span class="num">${item.discount}</span>`)}}></span>
                )
            }else{//如果显示‘折’
                return (
                    <span className="common-coupon">
                        {locale == 'ru' ? <span className="discount-txt">{this.__getServerLanguage('Zhe')+' '}</span>: ''}
                        <span className="num">{item.discount}<span className="percent-sign">%</span></span>
                        {locale == 'en' ? <span className="discount-txt">{' '+this.__getServerLanguage('Zhe')}</span>:''}
                    </span>
                )
            }

        }
        //满减
        if(type ==='full_reduce'){
            return (
                <span className="common-coupon common-coupon-money">
                    {/*<span className="coupon-unit">{item.symbol}</span><span className="coupon-num">{item.preferentialPrice}</span>*/}
                    <span className="coupon-num">{symbolMoneyUtil(item.preferentialPrice,item.symbol,this.window)}</span>
                </span>
            )
        }

        //现金券
        if(type ==='cash'){
            return (
                <span className="common-coupon common-coupon-money">
                    {/*<span className="coupon-unit">{item.symbol}</span><span className="coupon-num">{item.preferentialPrice}</span>*/}
                    <span className="coupon-num">{symbolMoneyUtil(item.preferentialPrice,item.symbol,this.window)}</span>
                </span>
            )
        }

        return <span></span>

    }
}

CommonCoupon.defaultProps = {
    // 优惠券种类 fullreduce:满减 discount:折扣 cash:现金券
    item:{}
}

CommonCoupon.propTypes = {

}
export default CommonCoupon;
